import type { Ordre } from "types/ordre";

/**
 * Pastille d'en-tête (modale ordre, fiche ordre) : qui a pris le RDV — le client sur
 * la page de réservation en ligne, ou le garage (prise de RDV interne). Rien pour un
 * ordre qui n'est pas né d'une réservation (import ServiceBox, création manuelle).
 */
export default function BookingOriginBadge({ ordre }: { ordre: Pick<Ordre, "booking_origin" | "booked_by_name"> }) {
  if (ordre.booking_origin !== "online" && ordre.booking_origin !== "internal") return null;
  const online = ordre.booking_origin === "online";
  const label = online ? "Résa client en ligne" : "Résa garage";
  const title = online
    ? "Rendez-vous pris par le client sur la page de réservation en ligne"
    : `Rendez-vous pris par le garage${ordre.booked_by_name ? ` (${ordre.booked_by_name})` : ""}`;
  return (
    <span
      className="inline-flex flex-row items-center gap-1.5 rounded-full px-2.5 py-0.5"
      style={online
        ? { background: "#EEF2FF", border: "1px solid #C7D2FE", whiteSpace: "nowrap" }
        : { background: "#F5F5F5", border: "1px solid #E5E5E5", whiteSpace: "nowrap" }}
      title={title}
    >
      <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke={online ? "#4F46E5" : "#525252"} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {online ? (
          <>
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
          </>
        ) : (
          <>
            <path d="M3 21V9l9-6 9 6v12" />
            <path d="M9 21v-6h6v6" />
          </>
        )}
      </svg>
      <span className="text-h4 font-semibold" style={{ color: online ? "#3730A3" : "#404040" }}>
        {label}{!online && ordre.booked_by_name ? ` · ${ordre.booked_by_name}` : ""}
      </span>
    </span>
  );
}
